/*
  The background wall: two very large soft lights on near-black, drifting and
  swelling on unrelated rhythms, under boiling film grain.

  WHY GRADIENTS AND NOT A NOISE FIELD: a noise field with more than one octave
  renders as smoke — that is how smoke is drawn. Gradients stay smooth however
  they move. The lights are deliberately LARGER than the viewport; an earlier
  version used smaller ones, you could see their edges, and they read as
  travelling bulbs rather than as the light shifting.

  WHY THE FREQUENCIES ARE ODD: 1.00, 0.83, 0.71, 0.62, 0.57, 0.44, 0.39 share
  no common factor, so the lights take hours to repeat a configuration.

  WHY THE GRAIN BOILS: cycling independent random tiles makes every pixel jump
  to an unrelated value each frame, which sparkles and looks digital. Film
  grain boils — each grain morphs, so every frame is a small perturbation of
  the last. The noise must therefore be random in SPACE but smooth in TIME.
  Each pixel gets its own phase and a frequency of 1, 2 or 3 cycles per loop
  and follows a sine across 30 baked frames; adjacent frames are cross-faded.
  Whole-number frequencies make the loop seamless. boil 0 restores the old
  independent-tile behaviour.

  TWO GRAIN PASSES, AND WHY THE SECOND ONE EXISTS:
  overlay compositing collapses toward zero as the base approaches black, so an
  overlay-only grain all but disappears in the darkest parts of the gradient —
  exactly where 8-bit banding shows as visible steps. The second pass uses
  lighter, which keeps its amplitude in shadow, and is what actually dithers
  the banding away. It lifts the blacks by a level or two, which is invisible
  and worth it. Do not remove it: the steps come straight back.

  BUDGET, because this is full-screen on phones:
  - grain tiles baked once at load, then only blended and tiled
  - life layer is an eighth-resolution overlay refreshed 12 times a second
  - dust uses fillRect, not arc, and is capped
  - composite runs at 30fps, stops when the tab is hidden
  - the layer is 100vh, never dvh: dvh resizes as the phone toolbar collapses,
    which drags the backdrop against the content

  Reduced motion draws one frame and stops rather than showing nothing.
*/
(function () {
  var host = document.querySelector('.bb-wall');
  if (!host || !host.getAttribute('data-bb')) return;
  var C;
  try { C = JSON.parse(host.getAttribute('data-bb')); } catch (e) { return; }

  var cv = host.querySelector('canvas');
  if (!cv || !cv.getContext) return;
  var x = cv.getContext('2d');
  if (!x) return;

  var still = C.reduce && window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hs(i, j, s) { var n = Math.sin(i * 127.1 + j * 311.7 + s * 74.7) * 43758.5453; return n - Math.floor(n); }
  function sm(a, b, k) { k = k * k * (3 - 2 * k); return a + (b - a) * k; }
  function n2(px, py, s) {
    var i = Math.floor(px), j = Math.floor(py), fx = px - i, fy = py - j;
    return sm(sm(hs(i, j, s), hs(i + 1, j, s), fx), sm(hs(i, j + 1, s), hs(i + 1, j + 1, s), fx), fy);
  }
  function nt(px, py, k) { var i = Math.floor(k), f = k - i; return sm(n2(px, py, i), n2(px, py, i + 1), f); }

  var W = 0, H = 0, dpr = 1, lw, lh, lc, lx, ld, D = [];
  var NF = 30, TS = 128, BOIL = [], RND = [], mix, mx;
  var t = 0, lastDraw = 0, lastLife = 0, raf = null;

  function bake() {
    BOIL = []; RND = [];
    var ph = new Float32Array(TS * TS), fr = new Uint8Array(TS * TS), i;
    for (i = 0; i < TS * TS; i++) { ph[i] = Math.random() * 6.283; fr[i] = 1 + ((Math.random() * 3) | 0); }
    for (var k = 0; k < NF; k++) {
      var ca = document.createElement('canvas'); ca.width = ca.height = TS;
      var xa = ca.getContext('2d'); var ia = xa.createImageData(TS, TS), da = ia.data;
      for (var p = 0, q = 0; p < TS * TS; p++, q += 4) {
        var g = ((0.5 + 0.5 * Math.sin(6.283 * k / NF * fr[p] + ph[p])) * 255) | 0;
        da[q] = da[q + 1] = da[q + 2] = g; da[q + 3] = 255;
      }
      xa.putImageData(ia, 0, 0); BOIL.push(ca);

      var cb = document.createElement('canvas'); cb.width = cb.height = TS;
      var xb = cb.getContext('2d'); var ib = xb.createImageData(TS, TS), db = ib.data;
      for (var r = 0; r < db.length; r += 4) {
        var n = (Math.random() * 255) | 0;
        db[r] = db[r + 1] = db[r + 2] = n; db[r + 3] = 255;
      }
      xb.putImageData(ib, 0, 0); RND.push(cb);
    }
    var sz = TS * C.gsize;
    mix = document.createElement('canvas'); mix.width = mix.height = sz;
    mx = mix.getContext('2d'); mx.imageSmoothingEnabled = false;
  }

  function dust() {
    D = [];
    if (C.dust <= 0 || !W) return;
    var n = Math.min(1100, Math.round((W * H) / (2600 * dpr) * (C.dust / 60)));
    for (var i = 0; i < n; i++) {
      var dk = Math.random() < 0.45;
      D.push({
        x: Math.random() * W, y: Math.random() * H,
        r: (0.32 + Math.random() * 0.5) * dpr,
        a: (dk ? 0.045 : 0.06) + Math.random() * 0.07,
        d: dk,
        vx: Math.random() - 0.5, vy: 0.2 + Math.random() * 0.7,
        w: Math.random() * 6.283, ws: 0.3 + Math.random()
      });
    }
  }

  function size() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    var cw = host.clientWidth || window.innerWidth;
    var ch = host.clientHeight || window.innerHeight;
    W = Math.round(cw * dpr); H = Math.round(ch * dpr);
    cv.width = W; cv.height = H;
    cv.style.width = cw + 'px'; cv.style.height = ch + 'px';
    lw = Math.max(16, Math.round(cw / 9)); lh = Math.max(16, Math.round(ch / 9));
    lc = document.createElement('canvas'); lc.width = lw; lc.height = lh;
    lx = lc.getContext('2d'); ld = lx.createImageData(lw, lh);
    dust(); life(); draw(performance.now());
  }

  function life() {
    if (C.life <= 0) return;
    var sc = 1 / 5.2, d = ld.data, k = 0;
    for (var j = 0; j < lh; j++) {
      for (var i = 0; i < lw; i++) {
        var v = nt(i * sc * 0.30, j * sc * 0.30, t * 1.4);
        var g = Math.round(90 + (v - 0.5) * 300);
        if (g < 0) g = 0; if (g > 255) g = 255;
        d[k++] = g; d[k++] = g; d[k++] = g; d[k++] = 255;
      }
    }
    lx.putImageData(ld, 0, 0);
  }

  function draw(ts) {
    var wm = C.warm, mv = C.move / 100, br = C.breath / 100;
    x.globalAlpha = 1; x.globalCompositeOperation = 'source-over';
    x.fillStyle = 'rgb(' + ((9 + wm * 0.3) | 0) + ',9,' + ((9 + wm * 0.5) | 0) + ')';
    x.fillRect(0, 0, W, H);

    var pulse = 1 + Math.sin(t * 0.83) * br * 0.30;
    var cx = W * 0.5 + Math.sin(t * 1.00) * W * mv * 0.34;
    var cy = H * (C.gy / 100) + Math.cos(t * 0.71) * H * mv * 0.26;
    var rr = H * (C.gsz / 100) * 1.55 * (1 + Math.sin(t * 0.57) * br * 0.22);
    var gl = (C.glow / 100) * pulse;
    var hi = Math.min(70, Math.round(46 * gl)), mid = Math.round(24 * gl);
    var rg = x.createRadialGradient(cx, cy, 0, cx, cy, Math.max(1, rr));
    rg.addColorStop(0, 'rgba(' + (hi + wm * 2) + ',' + hi + ',' + Math.max(0, hi - wm * 2) + ',1)');
    rg.addColorStop(0.42, 'rgba(' + (mid + wm) + ',' + mid + ',' + Math.max(0, mid - wm) + ',1)');
    rg.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = rg; x.fillRect(0, 0, W, H);

    if (C.second > 0) {
      var s2 = C.second / 100;
      var c2x = W * 0.5 - Math.sin(t * 0.62 + 1.7) * W * mv * 0.44;
      var c2y = H * 0.62 + Math.cos(t * 0.44 + 0.6) * H * mv * 0.30;
      var r2 = H * (C.gsz / 100) * 2.30 * (1 + Math.cos(t * 0.39) * br * 0.18);
      var h2 = Math.round(30 * s2 * (1 + Math.sin(t * 0.51) * br * 0.28));
      var rg2 = x.createRadialGradient(c2x, c2y, 0, c2x, c2y, Math.max(1, r2));
      rg2.addColorStop(0, 'rgba(' + (h2 + wm) + ',' + h2 + ',' + Math.max(0, h2 - wm) + ',1)');
      rg2.addColorStop(1, 'rgba(0,0,0,0)');
      x.globalCompositeOperation = 'lighter';
      x.fillStyle = rg2; x.fillRect(0, 0, W, H);
      x.globalCompositeOperation = 'source-over';
    }

    if (C.floor > 0) {
      var f = C.floor / 100;
      var lg = x.createLinearGradient(0, H * 0.60, 0, H);
      lg.addColorStop(0, 'rgba(255,255,255,' + (0.020 * f).toFixed(3) + ')');
      lg.addColorStop(0.30, 'rgba(255,255,255,' + (0.028 * f).toFixed(3) + ')');
      lg.addColorStop(0.42, 'rgba(0,0,0,' + (0.10 * f).toFixed(3) + ')');
      lg.addColorStop(1, 'rgba(0,0,0,' + (0.34 * f).toFixed(3) + ')');
      x.fillStyle = lg; x.fillRect(0, H * 0.60, W, H * 0.40);
    }

    if (C.life > 0) {
      x.globalAlpha = C.life / 150;
      x.globalCompositeOperation = 'overlay';
      x.imageSmoothingEnabled = true;
      x.drawImage(lc, 0, 0, W, H);
      x.globalAlpha = 1; x.globalCompositeOperation = 'source-over';
    }

    if (D.length) {
      for (var p = 0; p < D.length; p++) {
        var o = D[p];
        if (!still) {
          o.w += 0.008;
          o.x += (o.vx + Math.sin(o.w * o.ws) * 0.6) * 0.06 * dpr;
          o.y += o.vy * 0.03 * dpr;
          if (o.y > H + 2) o.y = -2;
          if (o.x > W + 2) o.x = -2;
          if (o.x < -2) o.x = W + 2;
        }
        x.fillStyle = (o.d ? 'rgba(0,0,0,' : 'rgba(240,237,230,') + o.a.toFixed(3) + ')';
        x.fillRect(o.x, o.y, o.r, o.r);
      }
    }

    if ((C.grain > 0 || C.dither > 0) && BOIL.length) {
      var b = C.boil / 100;
      var set = b > 0 ? BOIL : RND;
      var pos = still ? 0 : ts * 0.001 * C.shim;
      var i0 = Math.floor(pos) % NF;
      var fr2 = pos - Math.floor(pos);
      var sz = TS * C.gsize;
      mx.globalAlpha = 1;
      mx.clearRect(0, 0, sz, sz);
      mx.drawImage(set[i0], 0, 0, sz, sz);
      if (b > 0) {
        mx.globalAlpha = fr2 * b;
        mx.drawImage(set[(i0 + 1) % NF], 0, 0, sz, sz);
        mx.globalAlpha = 1;
      }
      var pat = x.createPattern(mix, 'repeat');

      if (C.grain > 0) {
        x.globalAlpha = C.grain / 420;
        x.globalCompositeOperation = 'overlay';
        x.fillStyle = pat; x.fillRect(0, 0, W, H);
      }
      if (C.dither > 0) {
        x.globalAlpha = C.dither / 6000;
        x.globalCompositeOperation = 'lighter';
        x.fillStyle = pat; x.fillRect(0, 0, W, H);
      }
      x.globalAlpha = 1; x.globalCompositeOperation = 'source-over';
    }
  }

  function loop(ts) {
    raf = requestAnimationFrame(loop);
    if (ts - lastDraw < 33) return;
    lastDraw = ts;
    t += 0.00040 * C.mspeed * 2;
    if (C.life > 0 && ts - lastLife > 83) { lastLife = ts; life(); }
    draw(ts);
  }

  function start() { if (!raf && !still) { lastDraw = 0; raf = requestAnimationFrame(loop); } }
  function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

  bake();
  size();
  start();

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      var cw = host.clientWidth || window.innerWidth;
      var ch = host.clientHeight || window.innerHeight;
      if (Math.abs(cw * dpr - W) < 2 && Math.abs(ch * dpr - H) < 2) return;
      size();
    }, 200);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop(); else start();
  });
})();
